import { validationTypesMessages } from 'src/features/validationTypes/utils/messages';
import { VALIDATION_TYPE } from 'src/features/validationTypes/utils/types';
import { BadgeOption } from 'src/registry/types/badges';
import { ICON_MAP } from 'src/utils/constants';

export const validationTypeBadgeOptions: Record<VALIDATION_TYPE, BadgeOption> = {
    [VALIDATION_TYPE.TIME]: {
        label: validationTypesMessages.time,
        icon: ICON_MAP.TIME,
        theme: 'blue',
    },
    [VALIDATION_TYPE.CHARGE]: {
        label: validationTypesMessages.charge,
        icon: ICON_MAP.CASH,
        theme: 'gray',
    },
    [VALIDATION_TYPE.WAIVE]: {
        label: validationTypesMessages.waive,
        icon: ICON_MAP.TIME,
        theme: 'green',
    },
    [VALIDATION_TYPE.GUEST]: {
        label: validationTypesMessages.guest,
        icon: ICON_MAP.MEMBER,
        theme: 'purple',
    },
    [VALIDATION_TYPE.PRICING_PLAN_CHANGE]: {
        label: validationTypesMessages.pricingPlanChange,
        icon: ICON_MAP.CIRCLE_EURO,
        theme: 'orange',
    },
};

export const VALIDATION_TYPE_TRANSLATION_MAP = {
    [VALIDATION_TYPE.TIME]: validationTypesMessages.time,
    [VALIDATION_TYPE.CHARGE]: validationTypesMessages.charge,
    [VALIDATION_TYPE.WAIVE]: validationTypesMessages.waive,
    [VALIDATION_TYPE.GUEST]: validationTypesMessages.guest,
    [VALIDATION_TYPE.PRICING_PLAN_CHANGE]: validationTypesMessages.pricingPlanChange,
};
